var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 46.7,
    height: 46.7,
    rx: 4.35,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 46.7,
    height: 46.7,
    rx: 4.35,
    stroke: "#DBDEE1",
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2328 18.5352H33.5985L30.9748 31.4348H14.3583L12.1719 25.7502L15.2328 18.5352Z",
    fill: "#314A52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0355 18.3161C32.3739 17.1792 30.6248 17.0042 29.9251 17.0042C28.5695 17.0042 27.4764 17.4415 26.5143 17.7913C25.7272 18.0537 25.0713 18.3161 24.4154 18.3161C23.7595 18.3161 23.1473 18.0537 22.4477 17.7476C21.5731 17.3978 20.6111 17.0042 19.4305 17.0042C18.0312 17.0042 11.7344 17.6602 11.7344 25.4874C11.7344 31.7405 16.938 37.9936 19.343 37.9936C20.305 37.9936 21.1358 37.7312 21.9667 37.4251C22.7975 37.1627 23.6283 36.8566 24.5903 36.8566C25.5523 36.8566 26.3832 37.119 27.214 37.4251C28.0448 37.7312 28.8756 37.9936 29.8377 37.9936C31.3244 37.9936 33.8606 35.5448 35.566 32.134C35.6972 31.8279 35.8721 31.5219 36.0033 31.2158C36.0907 30.9971 36.1782 30.7785 36.2656 30.5161C33.9481 29.5541 32.7674 27.4114 32.7674 24.8315C32.7674 23.2136 33.161 21.7706 34.0792 20.6336C34.4291 20.1964 34.8663 19.8028 35.3911 19.4967C34.9538 19.0595 34.4728 18.6222 34.0355 18.3161ZM30.9746 24.8752C30.9746 27.2803 28.6133 29.3355 25.1588 30.3412C23.9781 30.7348 22.3165 30.9971 20.4799 30.9971C17.3753 30.9971 14.7516 30.2975 14.1831 29.3792C13.7459 28.1111 13.4835 26.7993 13.4835 25.4874C13.4835 22.1204 14.7953 20.5899 16.0197 19.7591C17.3753 18.8845 18.9057 18.7534 19.4742 18.7534C20.1738 18.7534 20.786 18.972 21.5731 19.2781C21.6606 19.3218 21.7043 19.3218 21.7918 19.3655C22.4039 19.6279 23.4097 20.0652 24.4154 20.0652C25.0276 20.0652 25.5961 19.934 26.0771 19.7591C26.4269 19.6716 26.7767 19.4967 27.1265 19.3655C27.214 19.3218 27.3452 19.2781 27.4326 19.2781C28.2635 18.972 29.0506 18.7096 29.9251 18.7096C30.4061 18.7096 31.5868 18.8408 32.7237 19.4967C31.4556 21.0709 30.9746 22.9949 30.9746 24.8752ZM23.9781 16.1297C23.9781 12.7627 26.6893 10.0515 30.0563 10.0078C30.1 10.3139 30.1 10.5763 30.1 10.8824C30.1 14.2494 27.3889 16.9605 24.0219 17.0042C23.9781 16.6982 23.9781 16.4358 23.9781 16.1297Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStore);
export default __webpack_public_path__ + "static/media/apple-store.c51c639592b6d3676bf64e4b90bf80c5.svg";
export { ForwardRef as ReactComponent };